// extracted by mini-css-extract-plugin
export default {"container":"Value_container__I6rJa","bold":"Value_bold__1E7DK"};